<template>
  <div class="mx-auto my-0 max-w-4xl pt-0">
    <div
      v-if="
        checkoutStore.matchingCriteria.rids &&
        checkoutStore.matchingCriteria.rids.length !== 0
      "
      class="mx-auto mb-8 max-w-xl text-center"
    >
      <h1 class="font-boldtext-black mb-5 mt-0 text-xl">
        Next, estimate how many total hours of help you need for the
        {{ selectedRoles.length > 1 ? 'roles' : 'role' }} you selected.
      </h1>
      <p>
        Give us your best estimate, but don’t worry; you can always adjust your
        subscription hours later as needed.
      </p>
    </div>
    <p v-else class="my-01 text-center text-sm text-red-500">
      No keyword is selected. Please go back and select some keywords to proceed
    </p>
    <div
      v-if="
        checkoutStore.matchingCriteria.rids &&
        checkoutStore.matchingCriteria.rids.length !== 0
      "
      class="rounded-2xl border-2 p-4 md:px-5 md:py-6"
      :class="{ 'bg-white shadow-md': !checkoutStore.isInDialog }"
    >
      <p class="my-1 text-sm text-red-500" :class="{ invisible: !rolesError }">
        <span v-if="rolesEmptyError">
          No role is selected. Please go back and select roles first</span
        >
        <span v-else> Minimum of 10 hours needed</span>
      </p>

      <div
        v-for="(role, index) in selectedRoles"
        :key="role.value"
        class="grid grid-cols-4 place-content-center md:flex md:flex-col"
      >
        <div
          v-show="uiStore.mobile || (!uiStore.mobile && index === 0)"
          class="col-span-1 grid pt-4 md:flex md:flex-row md:items-center md:justify-between"
        >
          <p class="text-xs font-bold uppercase md:ml-2">role</p>
          <p class="text-xs font-bold uppercase md:pr-3">hours per month</p>
        </div>
        <div class="md:items-top col-span-3 grid md:flex">
          <div
            :class="{
              'flex flex-row items-center justify-end': uiStore.mobile,
            }"
          >
            <v-chip
              size="large"
              class="bg-vgsoftblue mb-2 w-44 px-7 py-3 text-black sm:w-auto"
            >
              <span class="truncate"> {{ role.value }}</span>
            </v-chip>
          </div>
          <div class="flex flex-auto flex-row items-center justify-end">
            <v-select
              :model-value="role.hours"
              :items="hoursItems"
              class="orange-text w-24 flex-none"
              variant="outlined"
              density="compact"
              @update:model-value="updateHours(role.id, $event)"
            ></v-select>
            <p class="ml-2 pb-4"></p>
          </div>
        </div>
      </div>
    </div>
    <ClientVAList
      :va-list="vasAvailabilityCheckList"
      :va-list-modal="showVAsToLoseModal"
      @remove="removeVAsWithInsufficientHours"
      @revert="revertHours"
    >
      <template #title>
        <p>By Changing hours you will lose these VAs:</p>
      </template>
    </ClientVAList>
  </div>
</template>
<script>
import { checkoutHoursItems } from '@/config';
import { mapStores } from 'pinia';
import { useCheckoutStore } from '@/stores/checkout';
import { useUiStore } from '@/stores/ui';
import { checkVAavailability } from '@/services/virtualAssistantsService';
import ClientVAList from '@/components/ClientVAList.vue';

export default {
  name: 'HoursSelector',
  components: { ClientVAList },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkoutHoursItems,
      requiredRules: [
        (v) => (!!v && parseInt(v) > 9) || 'Value greater than 9 required',
      ],
      showVAsToLoseModal: false,
      vasAvailabilityCheckList: [],
    };
  },
  computed: {
    ...mapStores(useUiStore, useCheckoutStore),
    selectedRoles() {
      return this.checkoutStore.selectedRoles.map((role) => {
        return {
          ...role,
          hours: this.checkoutStore.matchingCriteria.hours?.[
            this.getIndexOf(role.id)
          ],
          error: this.error
            ? this.checkoutStore.matchingCriteria.hours?.[
                this.getIndexOf(role.id)
              ] === undefined ||
              this.checkoutStore.matchingCriteria.hours?.[
                this.getIndexOf(role.id)
              ] === null
              ? true
              : false
            : false ||
              this.checkoutStore.matchingCriteria.hours?.[
                this.getIndexOf(role.id)
              ],
        };
      });
    },
    rolesError() {
      return (
        this.selectedRoles.some((role) => role.error === true) ||
        this.selectedRoles.length === 0
      );
    },
    rolesEmptyError() {
      return this.selectedRoles.length === 0;
    },
    hours() {
      return this.checkoutStore.matchingCriteria.hours ?? [];
    },
    hoursItems() {
      return [
        ...checkoutHoursItems,
        ...this.selectedRoles
          .filter(
            (role) =>
              role.hours &&
              !this.checkoutHoursItems.find((item) => item.value === role.hours)
          )
          .map((role) => {
            return { title: role?.hours?.toString(), value: role?.hours };
          }),
      ];
    },
  },
  async created() {
    if (
      this.checkoutStore.matchingCriteria?.rids?.length >
      this.checkoutStore.selectedRoles
    ) {
      {
        await this.checkoutStore.loadCriteriaByIds(
          (this.checkoutStore.matchingCriteria.cart?.length > 0
            ? this.checkoutStore.matchingCriteria.cart.map(
                (candidateVa) => candidateVa.role_id
              )
            : this.checkoutStore.matchingCriteria.rids
          ).join(',')
        );
      }
    }
    if (this.hours.length !== this.selectedRoles.length) {
      let hours = [...this.hours];
      hours.length = this.selectedRoles.length;
      hours.fill(10, this.hours.length, this.selectedRoles.length);
      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        hours,
      });
    }
  },

  methods: {
    async updateHours(id, value) {
      let hours =
        this.hours.length === 0
          ? Array(this.selectedRoles.length)
          : [...this.hours];
      hours[this.getIndexOf(id)] = value;
      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        hours,
      });
      await this.checkVAsInCartForNewHours();
    },
    async checkVAsInCartForNewHours() {
      if (!this.checkoutStore.matchingCriteria?.cart?.length) {
        return;
      }
      const newHours = this.checkoutStore.matchingCriteria.hours;
      const rids = this.checkoutStore.matchingCriteria.rids;

      //if a VA is selected for multiple roles add the greatest hours
      const selectedVas = this.checkoutStore.matchingCriteria.cart.reduce(
        (result, currentValue) => {
          result[currentValue.assistant_id] = result[currentValue.assistant_id]
            ? result[currentValue.assistant_id] >
              parseInt(newHours[rids.indexOf(currentValue.role_id)])
              ? result[currentValue.assistant_id]
              : parseInt(newHours[rids.indexOf(currentValue.role_id)])
            : parseInt(newHours[rids.indexOf(currentValue.role_id)]);
          return result;
        },
        {}
      );
      let vaAvailabilityList = [];
      Object.entries(selectedVas).forEach(([key, value]) => {
        vaAvailabilityList.push({ virtualAssistant_id: key, hours: value });
      });

      try {
        const result = await checkVAavailability(vaAvailabilityList).then(
          (response) => response.availability
        );

        this.vasAvailabilityCheckList = result
          .filter((VA) => VA.isAvailable === 0)
          .map((VA) => {
            const vaFromAvailabilityCheck = vaAvailabilityList.find(
              (va) => va.virtualAssistant_id === VA.uuid
            );
            return this.checkoutStore.matchingCriteria.cart.find(
              (va) =>
                va.assistant_id === VA.uuid &&
                va.role_id ===
                  rids[newHours.indexOf(vaFromAvailabilityCheck.hours)]
            );
          })
          .filter(Boolean);

        if (this.vasAvailabilityCheckList?.length > 0) {
          this.showVAsToLoseModal = true;
        } else {
          //update hours in cart
          let cartWithUpdatedHours = this.checkoutStore.matchingCriteria.cart.reduce(
            (result, currentValue) => {
              if (
                newHours[rids.indexOf(currentValue.role_id)] !==
                parseInt(currentValue.hours)
              ) {
                currentValue.hours =
                  newHours[rids.indexOf(currentValue.role_id)];
              }
              result.push(currentValue);
              return result;
            },
            []
          );
          await this.checkoutStore.updateMatchingCriteria({
            ...this.checkoutStore.matchingCriteria,
            cart: cartWithUpdatedHours,
          });
        }
      } catch (error) {
        this.revertHours();
        this.$root.$snackbar.error(
          error?.data?.message ?? 'Something happened please try again later.'
        );
      }
    },
    async revertHours() {
      //using data from cart to revert hours shown in query
      const ridsFromQuery = this.checkoutStore.matchingCriteria.rids;
      const hoursFromMatchingCriteria = this.checkoutStore.matchingCriteria
        .hours;

      this.checkoutStore.matchingCriteria.cart.forEach((va) => {
        hoursFromMatchingCriteria[ridsFromQuery.indexOf(va.role_id)] = va.hours;
      });

      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        hours: hoursFromMatchingCriteria,
      });

      this.showVAsToLoseModal = false;
    },
    async removeVAsWithInsufficientHours() {
      //update cart
      //1: remove vas that don't have enough hours
      //2: update the rest to have the selected new hours
      const ridsFromQuery = this.checkoutStore.matchingCriteria.rids;
      const hoursFromQuery = this.checkoutStore.matchingCriteria.hours;
      const newCart = this.checkoutStore.matchingCriteria.cart.reduce(
        (result, va) => {
          if (
            !this.vasAvailabilityCheckList.some(
              (vaToRemove) =>
                vaToRemove.role_id === va.role_id &&
                vaToRemove.assistant_id === va.assistant_id
            )
          ) {
            result.push({
              ...va,
              hours: hoursFromQuery[ridsFromQuery.indexOf(va.role_id)],
            });
          }
          return result;
        },
        []
      );
      await this.checkoutStore.updateMatchingCriteria({
        ...this.checkoutStore.matchingCriteria,
        cart: newCart,
      });

      this.showVAsToLoseModal = false;
    },
    getIndexOf(id) {
      return this.checkoutStore.matchingCriteria.rids.findIndex(
        (rid) => parseInt(rid) === id
      );
    },
  },
};
</script>
<style scoped>
.orange-text :deep(.v-text-field__slot input) {
  @apply text-vgorange;
}
</style>
